import configureStore from './configure-store';
const INITIAL_STATE = {};

const store = configureStore(INITIAL_STATE);

export default store;
